import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IAchievement, IAchievementDetails} from "../../models/achievement/response";
import {IAchievementQuery} from "../../models/achievement/query";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {ICreateAchievement, IUpdateAchievement} from "../../models/achievement/request";
import {createContext} from "react";

export type AchievementLoading =
    | "list"
    | "details"
    | "create"
    | "update"
    | "delete";

export interface IInternalState {
  loading: AchievementLoading[];
  list?: IBaseListingResponse<IAchievement>;
  query: IAchievementQuery;
  details?: IAchievementDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IAchievementDetails) => void;
    createAchievement: (request: ICreateAchievement) => void;
    updateAchievement: (id: number, request: IUpdateAchievement) => void;
    deleteAchievement: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IAchievementQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createAchievement: DEFAULT_FUNCTION,
    updateAchievement: DEFAULT_FUNCTION,
    deleteAchievement: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const AchievementContext = createContext(externalState);

export default AchievementContext;